import { useIntl } from 'react-intl';
import { Link } from 'react-router';

import { styled } from 'styled-components';

import OuraTextLogo from '../assets/oura-text.svg?react';

export const LogoLink = styled(Link)(
  ({ theme }) => `
  &:focus-visible {
    outline: 3px solid ${theme.colors.focusOutline};
    outline-offset: 5px;
  }
`,
);

interface OuraHeaderLogoProps {
  app: 'hub' | 'signup';
  height?: string;
  width?: string;
}

export const OuraHeaderLogo = ({ app, height = '19px', width = '60px' }: OuraHeaderLogoProps) => {
  const intl = useIntl();
  const hubHomePage = '/';

  if (app === 'hub') {
    return (
      <LogoLink to={hubHomePage} aria-label={intl.formatMessage({ id: 'membership_homepage_link' })}>
        <OuraTextLogo height={height} width={width} flex-shrink="0" />
      </LogoLink>
    );
  }
  return <OuraTextLogo height={height} width={width} flex-shrink="0" />;
};
